/* eslint-disable @typescript-eslint/no-explicit-any */
// variableReducer.ts

import { SET_LANGUAGE_VAR, GET_LANGUAGES_LIST, SET_AGENT_LANGUAGE, GET_IPINFO_ACTIONTYPE } from "../actionTypes/variableActionTypes";

const initialState = {
  value: "en", // Initialize your variable
  languageDropDown:[],
  ipAddress:{},
};

const variableReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LANGUAGE_VAR:
      return {
        ...state,
        value: action.payload, // Update the variable
      };
      case SET_AGENT_LANGUAGE.FULLFILLED:
        return { ...state,value:action.payload?.request };
        case GET_IPINFO_ACTIONTYPE.FULLFILLED:
          return { ...state,ipAddress:action.payload };
    case GET_LANGUAGES_LIST.FULLFILLED:
      return { ...state, languageDropDown: action.payload };
    default:
      return state;
  }
};

export default variableReducer;
